 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"npm.flickity":"npm.flickity","npm.vue-flickity":"npm.vue-flickity","npm.desandro-matches-selector":"npm.desandro-matches-selector"}[chunkId]||chunkId) + "." + {"chunk-2d0a47c2":"e22eff64","chunk-2d0aac9e":"95d38148","chunk-2d0c4303":"ff0c8100","chunk-2d0c7cf2":"acd93b0e","chunk-2d0cc598":"32a4ac80","chunk-2d0ce83a":"92de0635","chunk-2d0cfa75":"34878f1e","chunk-2d0db28a":"b4fe8d22","chunk-2d0e1f3f":"d38ef67c","chunk-2d0e8c24":"1d5c0dd0","chunk-2d2082da":"0b952ab5","chunk-2d2131a8":"b53063a4","chunk-2d213e1c":"50be65b3","chunk-2d216d4b":"eaf9ec83","chunk-2d21767b":"1f618f64","chunk-2d21b2ae":"addc9a5f","chunk-2d21eae7":"f4611a25","chunk-2d221f1b":"d3fbe1c4","chunk-2d225861":"6acf2166","chunk-2d22c303":"0812fa2f","chunk-2d22ccf1":"0dc5745f","chunk-2d22d626":"fdb690a6","chunk-2d230a47":"fccb1b5c","chunk-837f7898":"f124b4f9","chunk-2d237b3f":"db72d4b1","chunk-2d0d6355":"b6d982c1","chunk-4feb0a85":"10df498e","chunk-6f7abfe7":"fd37939e","chunk-d3664048":"28f56bda","chunk-8daa19ae":"3c3de19e","chunk-14b69cb4":"91bd4090","chunk-2d0a4b20":"9a1ff361","chunk-2d0c8f77":"d2680be7","chunk-2d0db476":"17d34e5c","chunk-2d213ee9":"cfa67aa6","chunk-2d0abbe3":"785f92b9","chunk-2d0b696a":"e83b5923","chunk-2d216ee9":"d6dc4515","chunk-2d22c101":"a510b5fe","chunk-2d2304b8":"278f15e9","chunk-72895ade":"f1e5b66b","chunk-63a9d69e":"f2e45de1","chunk-4899cca2":"3c226f85","chunk-58326d7f":"4e5f2807","chunk-2d21728c":"3e838f7f","chunk-3a10b24c":"c3959d37","chunk-6690e3ae":"c02409a6","chunk-460aa83b":"c5b27e6f","chunk-7508d650":"44a11d29","chunk-2d225d97":"1d1ebb78","chunk-078607a8":"b8c61af9","chunk-086fd2f2":"f9883445","chunk-28a50674":"441f188c","chunk-57b8622a":"fac0ff48","chunk-dd246c4a":"12b1fc8c","chunk-30fd6036":"ebadd027","npm.flickity":"4091940e","npm.vue-flickity":"597a54c0","npm.desandro-matches-selector":"c61fd67c","chunk-30581dcf":"1a577bb1","chunk-c3fe68c0":"b05d8ccd","chunk-31cd676e":"756c52fe","chunk-70b9cb64":"ab076209","chunk-2053f1d4":"bcf50542"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-6f7abfe7":1,"chunk-d3664048":1,"chunk-8daa19ae":1,"chunk-14b69cb4":1,"chunk-72895ade":1,"chunk-7508d650":1,"chunk-30fd6036":1,"npm.flickity":1,"chunk-31cd676e":1,"chunk-70b9cb64":1,"chunk-2053f1d4":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"npm.flickity":"npm.flickity","npm.vue-flickity":"npm.vue-flickity","npm.desandro-matches-selector":"npm.desandro-matches-selector"}[chunkId]||chunkId) + "." + {"chunk-2d0a47c2":"31d6cfe0","chunk-2d0aac9e":"31d6cfe0","chunk-2d0c4303":"31d6cfe0","chunk-2d0c7cf2":"31d6cfe0","chunk-2d0cc598":"31d6cfe0","chunk-2d0ce83a":"31d6cfe0","chunk-2d0cfa75":"31d6cfe0","chunk-2d0db28a":"31d6cfe0","chunk-2d0e1f3f":"31d6cfe0","chunk-2d0e8c24":"31d6cfe0","chunk-2d2082da":"31d6cfe0","chunk-2d2131a8":"31d6cfe0","chunk-2d213e1c":"31d6cfe0","chunk-2d216d4b":"31d6cfe0","chunk-2d21767b":"31d6cfe0","chunk-2d21b2ae":"31d6cfe0","chunk-2d21eae7":"31d6cfe0","chunk-2d221f1b":"31d6cfe0","chunk-2d225861":"31d6cfe0","chunk-2d22c303":"31d6cfe0","chunk-2d22ccf1":"31d6cfe0","chunk-2d22d626":"31d6cfe0","chunk-2d230a47":"31d6cfe0","chunk-837f7898":"31d6cfe0","chunk-2d237b3f":"31d6cfe0","chunk-2d0d6355":"31d6cfe0","chunk-4feb0a85":"31d6cfe0","chunk-6f7abfe7":"8da8fd97","chunk-d3664048":"5b694e9d","chunk-8daa19ae":"e1ed83ba","chunk-14b69cb4":"0e49e4c8","chunk-2d0a4b20":"31d6cfe0","chunk-2d0c8f77":"31d6cfe0","chunk-2d0db476":"31d6cfe0","chunk-2d213ee9":"31d6cfe0","chunk-2d0abbe3":"31d6cfe0","chunk-2d0b696a":"31d6cfe0","chunk-2d216ee9":"31d6cfe0","chunk-2d22c101":"31d6cfe0","chunk-2d2304b8":"31d6cfe0","chunk-72895ade":"c4d9801c","chunk-63a9d69e":"31d6cfe0","chunk-4899cca2":"31d6cfe0","chunk-58326d7f":"31d6cfe0","chunk-2d21728c":"31d6cfe0","chunk-3a10b24c":"31d6cfe0","chunk-6690e3ae":"31d6cfe0","chunk-460aa83b":"31d6cfe0","chunk-7508d650":"4083d5a1","chunk-2d225d97":"31d6cfe0","chunk-078607a8":"31d6cfe0","chunk-086fd2f2":"31d6cfe0","chunk-28a50674":"31d6cfe0","chunk-57b8622a":"31d6cfe0","chunk-dd246c4a":"31d6cfe0","chunk-30fd6036":"ae4cb0af","npm.flickity":"f28472e8","npm.vue-flickity":"31d6cfe0","npm.desandro-matches-selector":"31d6cfe0","chunk-30581dcf":"31d6cfe0","chunk-c3fe68c0":"31d6cfe0","chunk-31cd676e":"3998f208","chunk-70b9cb64":"52ca11b9","chunk-2053f1d4":"3998f208"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
